goog.provide('el8.appchart.dialog.selectFile');

goog.require('el8.template.appchart.dialog.selectFile');
goog.require('el8.ptdata.reports');
goog.require('el8.app.pageLayout');
goog.require('el8.uiwidget.NewDialog');

el8.appchart.dialog.selectFile = (function() {

    var contentSelector = '.select-file-content';
    var selectFn = null;

    var that = new el8.uiwidget.NewDialog({
        title: 'Select a file',
        autoHeight: true,
        width: 500
    });
    
    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'select', 'Choose selected file', function() {
            if( selectFn ) {
                selectFn( getSelectedFiles(), function() { that.hide(); } );
            }
        }, true
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);
    
    var super_hide = that.hide;
    that.hide = function() {
        $(contentSelector, that.getContainer()).addClass('feedLoading');
        buttonSet.disableButton('select');
        super_hide.call(that);
    };
    
    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);

        spec = spec || {};
        selectFn = spec.selectFn || null;

        if (spec.title) { that.setTitle(spec.title); }
        if (spec.btnText) { buttonSet.updateButtonCaption('select', spec.btnText); }
        
        var sortFn = function(a, b) { return b.getDocumentDate().getTime() - a.getDocumentDate().getTime(); };
        var allReports = el8.ptdata.reports.all().sort(sortFn);
        var filteredReports = [];
        for (var i=0, numReports=allReports.length; i<numReports; i++) {
            if (allReports[i].getId() !== spec.reportId &&
                    ((allReports[i].getReportType() !== 'lab') || !allReports[i].hasGrids())) {
                filteredReports.push({
                    id : allReports[i].getId(),
                    noteSummary : allReports[i].getNoteSummary()
                });
            }
        }
        that.setContent(el8.template.appchart.dialog.selectFile.content({
            message: spec.message || null,
            instructions: spec.instructions || null,
            reports: filteredReports
        }));
        
        $(contentSelector, that.getContainer()).removeClass('feedLoading');
        buttonSet.enableButton('select');
        that.adjustHeight();
    };
    
    var getSelectedFiles = function() {
        var result = [];
        that.getContainer().find('input').each( function() {
            if( $(this).is(':checked') ) {
                result.push( $(this).val() );
            }
        });
        return result;
    };
    
    return that;

})();
